export const initialPricing = {
  getJourneyPriceRequest: [
    {
      addOnProductTypes: [
        1
      ],
      journeyDirection: null,
      airportLocation: null,
      airlineCode: null,
      postCode: '',
      geocoord: {
        latitude: 0,
        longitude: 0
      },
      collectionDateTimeUTC: '',
      deliveryDateTimeUTC: '',
      numberOfBags: null,
      numberOfOversizedBags: null,
      productTierId: '',
      timeslotId: '',
      flightDateTime: '',
      flightDepartureAirportCode: '',
      isDoorToDoorBooking: false
    }
  ],
  promoCodes: [],
  userEmailAddress: null,
  languageCode: 'en',
  isFromTimeSlotPage: false,
  applySbbSubsidy: false,
  applyDbSubsidy: false,
  applyCatDiscount: false,
  dbSubsidyType: null,
  slotNumber : 'a',
  isAmend: false
};
